import { PropTypes } from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import PageError from '@zenbusiness/zui/PageError';
import Stack from '@zenbusiness/zui/Stack';

import InvoiceCard from './components/InvoiceCard';
import PaymentOrderInfo from './components/PaymentOrderInfo';
import {
  KlarnaLandingContainer,
  KlarnaLandingCompanyName,
  KlarnaLandingSubtitle,
  KlarnaLandingEmptyState
} from './KlarnaLanding.style';

const MESSAGE_IDS = {
  title: 'dashboard.klarnaLanding.title',
  subtitle: 'dashboard.klarnaLanding.subtitle',
  noInvoices: 'dashboard.klarnaLanding.noInvoices'
};

// Mock data for UI-only development — will be replaced by hook data in ECOMM-2318
const MOCK_INVOICES = [
  {
    id: 'inv-001', amount: 349.0, dueDate: 'Feb 14, 2026', avatarUrl: ''
  },
  {
    id: 'inv-002', amount: 199.0, dueDate: 'Feb 14, 2026'
  },
  {
    id: 'inv-003', amount: 79.0, dueDate: 'Feb 14, 2026'
  }
];

const MOCK_COMPANY_NAME = 'BLUE HORIZON LLC';

function KlarnaLanding({ companyName = MOCK_COMPANY_NAME, invoices = MOCK_INVOICES }) {
  return (
    <ErrorBoundary fallback={<PageError />} id="src/pages/KlarnaLanding">
      <KlarnaLandingContainer>
        <Stack spacing={3}>
          <Box>
            <KlarnaLandingCompanyName>
              {companyName}
            </KlarnaLandingCompanyName>
            <Heading component="h1" size="lg" weight="medium">
              <FormattedMessage id={MESSAGE_IDS.title} />
            </Heading>
            <KlarnaLandingSubtitle>
              <FormattedMessage id={MESSAGE_IDS.subtitle} />
            </KlarnaLandingSubtitle>
          </Box>

          {invoices.length > 0 ? (
            <>
              {invoices.map((invoice, index) => (
                <InvoiceCard
                  key={invoice.id}
                  amount={invoice.amount}
                  avatarUrl={invoice.avatarUrl}
                  dueDate={invoice.dueDate}
                  isLocked={index > 0}
                  // TODO: wire onPayWithKlarna and onPayWithAnotherMethod in ECOMM-2318
                />
              ))}
              <PaymentOrderInfo />
            </>
          ) : (
            <KlarnaLandingEmptyState>
              <FormattedMessage id={MESSAGE_IDS.noInvoices} />
            </KlarnaLandingEmptyState>
          )}
        </Stack>
      </KlarnaLandingContainer>
    </ErrorBoundary>
  );
}

KlarnaLanding.propTypes = {
  companyName: PropTypes.string,
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      dueDate: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string
    })
  )
};

export default KlarnaLanding;
